import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IIntegrationComponentInput } from 'src/app/models/componentInputs';
import { PopUpHeight, PopUpStyling, PopUpWidth } from 'src/app/models/constants/popup.constants';
import { PermissionsService } from 'src/app/services/infra/permissionsService/permissions.service';
import { IntegrationComponent } from 'src/app/views/integration/integration.component';

@Component({
  selector: 'app-dashboard-new-org',
  templateUrl: './dashboard-new-org.component.html',
  styleUrls: ['./dashboard-new-org.component.scss'],
})
export class DashboardNewOrgComponent {
  constructor(
    private readonly _router: Router,
    public dialog: MatDialog,
    public permissionsService: PermissionsService
  ) {}

  public addIntegrationClicked(): void {
    this._router.navigateByUrl('/app/integrations');
  }

  private _openConnectionDialog(input: IIntegrationComponentInput): MatDialogRef<IntegrationComponent> {
    return this.dialog.open(IntegrationComponent, {
      height: PopUpHeight,
      width: PopUpWidth,
      data: input,
      panelClass: PopUpStyling,
    });
  }
}
